import React from 'react';

const AnimatedLockIcon = (props) => {
	const status = (props.status != undefined) ? props.status : false;

	return (
		<span class={`animated_lock_icon${(status) ? ' is_opening' : ''}`}>
			<svg width="30px" height="30px" viewBox="0 0 30 30">
				<g class="all_group" transformOrigin="8.5, 16.5">
					<clipPath id="locker_clip">
						<rect x="2" y="1" width="21" height="8.5"/>
					</clipPath>

					<g clipPath="url(#locker_clip)">
						<path class="locker" d="M4.5,10V8c0-2.21,1.79-4,4-4s4,1.79,4,4v4"/>
					</g>

					<rect class="lock_box" x="1.5" y="9.50" width="14" height="14"/>

					<path class="key" d="M10.25,14.75c0-0.97-0.78-1.75-1.75-1.75s-1.75,0.78-1.75,1.75c0,0.6,0.3,1.12,0.76,1.44L6.75,20h3.5l-0.76-3.81C9.95,15.87,10.25,15.35,10.25,14.75z"/>
				</g>
			</svg>
		</span>
	)
}

export default AnimatedLockIcon;